import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfigService } from '@app/shared/services/app-config.service';
import { Observable } from 'rxjs';
import { Configuration, ConfigurationsGroup } from './models/configuration';

@Injectable({
  providedIn: 'root',
})
export class ConfigurationService {
  baseUrl = `${AppConfigService.settings.apiUrl}Configurations/`;
  constructor(private http: HttpClient) {}

  getAll(): Observable<ConfigurationsGroup[]> {
    return this.http.get<ConfigurationsGroup[]>(this.baseUrl);
  }

  getConfigurationGroup(id: number): Observable<ConfigurationsGroup> {
    return this.http.get<ConfigurationsGroup>(this.baseUrl + id.toString());
  }

  getConfigurationValue(code: string): Observable<Configuration> {
    return this.http.get<Configuration>(
      this.baseUrl + 'configuration-value/' + code
    );
  }
  put(configurations: any) {
    return this.http.put(
      this.baseUrl + 'update-configurations',
      configurations
    );
  }
}
